<template>
    <div class="page-cabinet-requests-item-content">
        <template v-if="investment.status === 'wait_sign'">
            <div class="page-cabinet-requests-item-content__title"
                v-text="'Подписание документов'"
            />
            <div class="page-cabinet-requests-item-content__description"
                v-text="'Необходимо принять условия инвестиционного предложения и подписать договор инвестирования.'"
            />
            <div class="page-cabinet-requests-item-content__documents"
                v-if="documents.length > 0"
                >
                <div class="page-cabinet-requests-item-content__documents-item"
                    v-for="(document, i) in documents"
                    v-bind:key="i"
                    >
                    <page-cabinet-requests-item-content-document
                        v-bind:document="document"
                    />
                </div>
            </div>
            <common-sms-verification-block v-bind:phone="user.phone" v-if="user.phone">
                <common-sms-verification
                    v-bind:phone="user.phone"
                    v-on:submit="onSubmit"
                    button-custom-text="Подписать"
                    purpose-text="подписания документов"
                    is-request-required
                />
            </common-sms-verification-block>
            <div class="page-cabinet-requests-item-content__verification"
                v-else
                >
                <div class="page-cabinet-requests-item-content__verification-title"
                    v-text="'Для подтверждения заявки необходим номер телефона.'"
                />
                <div class="page-cabinet-requests-item-content__verification-title"
                    v-text="'Вы можете добавить его в профиле.'"
                />
                <div class="page-cabinet-requests-item-content__verification-phone"
                    v-text="'Телефон не указан'"
                />
                <div class="page-cabinet-requests-item-content__verification-button">
                    <ui-button
                        v-bind:href="profileUrl"
                        target="_blank"
                        >
                        Редактировать профиль
                    </ui-button>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="page-cabinet-requests-item-content__title"
                v-text="'Подпись не требуется'"
            />
            <div class="page-cabinet-requests-item-content__description"
                v-text="'На данный момент статус заявки не требует ее подтверждения и подписи'"
            />
        </template>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import config from '~/config';

export default {
    name: 'page-cabinet-requests-item-content',
    props: {
        investment: {
            type: Object,
        },
        user: {
            type: Object,
        },
        documents: {
            type: Array,
        },
    },
    data: () => ({
        profileUrl: config.urls.cabinet.personalData,
        isCodeCheckInitiated: false,
    }),
    computed: {
        ...mapState('investments', [ 'verifyUserInvestmentRequestResult' ]),
    },
    methods: {
        requestCode() {
            this.isCodeCheckInitiated = true;
        },
        onSubmit(code) {
            this.$store.dispatch('investments/verifyUserInvestmentRequest', { code, value: this.user.phone, id: this.investment.id });
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.page-cabinet-requests-item-content {
    padding: 8px;
    &__title {
        .typography-large();

        margin-bottom: 16px;
    }
    &__description {
        .typography-body();

        max-width: 760px;
        margin-bottom: 16px;
    }
    &__documents {
        margin-bottom: 40px;
        &-item {
            &:not(:last-child) {
                margin-bottom: 12px;
            }
        }
    }
    @media @media-sm-down {
        padding: 0;
        &__title {
            .typography-medium();

            margin-bottom: 8px;
        }
    }
}
</style>
